/* eslint-disable */
import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { Px } from '../assets/posize';
import HeaderBlack from '../components/HeaderBlack';

export default function SOUL6(props) {
  return (
    <div
      style={{
        '--src': `url(${
          require('assets/d40fc322505e9ffbf065741c4bf7b7db.png').default
        })`
      }}
      className={`s-ou-l6 ${css(styles.group, styles.group_layout)}`}
    >
      <div className={css(styles.cover_group, styles.cover_group_layout)}>
        <div className={css(styles.group1, styles.group1_layout)}>
          <h1 className={css(styles.big_title, styles.big_title_layout)}>
            {'擁有銀鈴笑聲的小仙子'}
          </h1>
          <h4 className={css(styles.highlights, styles.highlights_layout)}>
            {'你/妳的靈魂是'}
          </h4>
          <h5 className={css(styles.highlights1, styles.highlights1_layout)}>
            {
              '當新生嬰兒第一次咯咯的笑出聲，他的笑聲會破裂成一千片，這些碎片到處飛，誕生出一千個晶瑩的小仙子。小仙子擁有冰塊般明亮的翅膀，靈活輕快的在森林中穿梭，有想法的你，聰明、靈巧，還有點頑皮。'
            }
          </h5>

          <div
            onClick={() => window.open('/soul', '_self')}
            className={`${css(
              styles.group2,
              styles.group2_layout
            )} cursor-pointer to-more`}
          >
            <h5 className={css(styles.highlights2, styles.highlights2_layout)}>
              {'五感靈魂樣貌'}
            </h5>
          </div>

          <div
            style={{
              '--src': `url(${
                require('assets/5829425e44659ffcbf100d6c5e345142.png').default
              })`
            }}
            className={css(styles.cover_group1, styles.cover_group1_layout)}
          >
            <div
              style={{
                '--src': `url(${
                  require('assets/577a464911332616a2929c4036fe7032.png').default
                })`
              }}
              className={css(styles.image, styles.image_layout)}
            />
          </div>

          <h4 className={css(styles.highlights3, styles.highlights3_layout)}>
            {'推薦給你：野溪邊的茶・冰釀果酸有機紅烏龍'}
          </h4>
          <div
            className={css(styles.paragraph_body, styles.paragraph_body_layout)}
          >
            {
              '冷泡讓沁涼的果香變得更加明亮銳利，本來屬於悠遠森林的秘密境界，搖身一變成為帶有童話氣息的風味想像。'
            }
          </div>
          <div
            className={css(
              styles.small_paragraph_body,
              styles.small_paragraph_body_layout
            )}
          >
            {'百香果、莓果酒香、清新草本、黃檸檬、芬多精、酢漿草'}
          </div>

          <div className={css(styles.group3, styles.group3_layout)}>
            <div
              className={css(
                styles.small_text_body,
                styles.small_text_body_layout
              )}
            >
              {'風味標籤'}
            </div>
          </div>

          <div
            className={css(
              styles.small_text_body1,
              styles.small_text_body1_layout
            )}
          >
            {'輕盈'}
          </div>

          <div className={css(styles.group4, styles.group4_layout)}>
            <div
              style={{
                '--src': `url(${
                  require('assets/725e0881999200f80f03a4901e2c874d.svg').default
                })`
              }}
              className={css(styles.decorator, styles.decorator_layout)}
            />

            <div className={css(styles.group5, styles.group5_layout)}>
              <div
                style={{
                  '--src': `url(${
                    require('assets/a9195eb0adc1d9df028134268f3709a8.svg')
                      .default
                  })`
                }}
                className={css(styles.img, styles.img_layout)}
              />
            </div>

            <div className={css(styles.group6, styles.group6_layout)}>
              <div
                style={{
                  '--src': `url(${
                    require('assets/d82a41ec31eea74dc36761400e02cb3c.svg')
                      .default
                  })`
                }}
                className={css(styles.img, styles.img_layout)}
              />
            </div>

            <div className={css(styles.group7, styles.group7_layout)}>
              <div
                style={{
                  '--src': `url(${
                    require('assets/504540321007533130a837053809a415.svg')
                      .default
                  })`
                }}
                className={css(styles.img, styles.img_layout)}
              />
            </div>

            <div className={css(styles.group8, styles.group8_layout)}>
              <div
                style={{
                  '--src': `url(${
                    require('assets/95ba3828c2d22154c5de583ddc5b3c74.svg')
                      .default
                  })`
                }}
                className={css(styles.img, styles.img_layout)}
              />
            </div>
          </div>

          <div className={css(styles.group9, styles.group9_layout)}>
            <div
              className={css(
                styles.small_text_body,
                styles.small_text_body_layout1
              )}
            >
              {'茶體'}
            </div>
          </div>

          <div className={css(styles.flex, styles.flex_layout)}>
            <div className={css(styles.flex_item)}>
              <div className={css(styles.flex1, styles.flex1_layout)}>
                <div className={css(styles.flex_item1)}>
                  <div
                    style={{
                      '--src': `url(${
                        require('assets/2b052833509f4ee639e040bcd288ed95.png')
                          .default
                      })`
                    }}
                    className={css(styles.image, styles.image_layout1)}
                  />
                </div>
                <div className={css(styles.flex_spacer)} />
                <div
                  className={css(
                    styles.small_text_body2_box,
                    styles.small_text_body2_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body2)}>
                    <span className={css(styles.small_text_body2_span0)}>
                      {'600ml'}
                    </span>
                    <span className={css(styles.small_text_body2_span1)}>
                      {' 冷萃'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={css(
                styles.small_text_body3_box,
                styles.small_text_body3_box_layout
              )}
            >
              <div className={css(styles.small_text_body3)}>
                <span className={css(styles.small_text_body3_span0)}>
                  {'茶葉 '}
                </span>
                <span className={css(styles.small_text_body3_span1)}>
                  {'6g'}
                </span>
                <span className={css(styles.small_text_body3_span2)}>
                  {' / 茶包'}
                </span>
                <span className={css(styles.small_text_body3_span3)}>
                  {'2'}
                </span>
                <span className={css(styles.small_text_body3_span4)}>
                  {'個'}
                </span>
              </div>
            </div>
            <div
              className={css(
                styles.small_text_body4,
                styles.small_text_body4_layout
              )}
            >
              {'水溫：常溫'}
            </div>
            <div
              className={css(
                styles.small_text_body5_box,
                styles.small_text_body5_box_layout
              )}
            >
              <div className={css(styles.small_text_body5)}>
                <span className={css(styles.small_text_body5_span0)}>
                  {'時間：放冰箱'}
                </span>
                <span className={css(styles.small_text_body5_span1)}>
                  {'24'}
                </span>
                <span className={css(styles.small_text_body5_span2)}>
                  {'小時，搖勻後飲用'}
                </span>
              </div>
            </div>
          </div>

          <div className={css(styles.group10, styles.group10_layout)}>
            <div
              className={css(
                styles.small_text_body,
                styles.small_text_body_layout2
              )}
            >
              {'泡法'}
            </div>
          </div>

          <div
            onClick={() =>
              window.open(
                'https://www.daughter-tea.com/product.aspx?openExternalBrowser=1&Id=11'
              )
            }
            className={`${css(
              styles.group11,
              styles.group11_layout
            )} cursor-pointer to-more`}
          >
            <h5 className={css(styles.highlights4, styles.highlights4_layout)}>
              {'了解更多'}
            </h5>
          </div>

          <div
            onClick={() => window.open('/', '_self')}
            className={`${css(
              styles.group12,
              styles.group12_layout
            )} cursor-pointer to-home`}
          >
            <div className={css(styles.background, styles.background_layout)} />
            <h5 className={css(styles.highlights5, styles.highlights5_layout)}>
              {'重新探索'}
            </h5>
          </div>

          <h4 className={css(styles.highlights6, styles.highlights6_layout)}>
            {'專屬於你的風味想像'}
          </h4>
          <div
            className={css(
              styles.paragraph_body,
              styles.paragraph_body_layout1
            )}
          >
            {
              '明明是輕盈的在空中飛舞，卻不停出現細微的清脆碰撞聲。翠綠色與白色的飛行軌跡，比森林的顏色更亮一階，時而勾引你的目光，變成星星般的亮粉消失在畫面邊緣。'
            }
          </div>
          <div
            style={{
              '--src': `url(${
                require('assets/c245b3e704bfbc9d157aae4ceedd381b.png').default
              })`
            }}
            className={css(styles.decorator1, styles.decorator1_layout)}
          />
        </div>

        <div className={css(styles.component, styles.component_layout)}>
          <HeaderBlack
            icon={
              require('assets/d322d14b233070bbff024a1a56d1eb66.png').default
            }
            image={
              require('assets/c6b10e4947e78c4196251481415c35c3.png').default
            }
          />
        </div>
      </div>
    </div>
  );
}

SOUL6.inStorybook = true;

const styles = StyleSheet.create({
  group: {
    display: 'flex',
    background: 'var(--src) center center / cover no-repeat',
    backgroundColor: 'rgb(255,255,255)'
  },
  group_layout: {
    position: 'relative',
    minHeight: 1649,
    flexGrow: 1
  },
  cover_group: {
    display: 'flex',
    backgroundColor: 'rgb(231,240,230)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group_layout: {
    position: 'relative',
    minHeight: 1649,
    width: 375,
    minWidth: 375,
    margin: '0px auto'
  },
  group1: {
    display: 'flex'
  },
  group1_layout: {
    position: 'relative',
    height: 1543,
    flexGrow: 1,
    margin: '53px 13px'
  },
  big_title: {
    display: 'flex',
    alignItems: 'center',
    font: '500 30px/1.8 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  big_title_layout: {
    position: 'absolute',
    flexGrow: 1,
    inset: '368px 3px 1133px'
  },
  highlights: {
    display: 'flex',
    alignItems: 'center',
    font: '18px/1.79 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px',
    opacity: 0.69
  },
  highlights_layout: {
    position: 'absolute',
    flexGrow: 1,
    inset: '342px 3px 1183px'
  },
  highlights1: {
    font: '16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights1_layout: {
    position: 'absolute',
    flexGrow: 1,
    inset: '432px 3px 971px'
  },
  group2: {
    display: 'flex',
    backgroundColor: 'rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  group2_layout: {
    position: 'absolute',
    minHeight: 44,
    flexGrow: 1,
    inset: '586px 3px 913px'
  },
  highlights2: {
    display: 'flex',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights2_layout: {
    width: 96,
    minWidth: 96,
    margin: '8px auto'
  },
  cover_group1: {
    display: 'flex',
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group1_layout: {
    position: 'absolute',
    minHeight: 257,
    flexGrow: 1,
    inset: '70px 3px 1216px'
  },
  image: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image_layout: {
    height: 69,
    width: 53,
    minWidth: 53,
    margin: '111px 78px 77px auto'
  },
  highlights3: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights3_layout: {
    position: 'absolute',
    flexGrow: 1,
    inset: '1114px 3px 373px'
  },
  paragraph_body: {
    font: '14px/1.57 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  paragraph_body_layout: {
    position: 'absolute',
    flexGrow: 1,
    inset: '1185px 3px 292px'
  },
  small_paragraph_body: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_paragraph_body_layout: {
    position: 'absolute',
    flexGrow: 1,
    inset: '1267px 3px 236px 70px'
  },
  group3: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  group3_layout: {
    position: 'absolute',
    width: 59,
    minWidth: 59,
    inset: '1267px auto 254px 3px'
  },
  small_text_body: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px'
  },
  small_text_body_layout: {
    height: 19,
    width: 48,
    minWidth: 48,
    margin: '0.5px 0px 0px 6px'
  },
  small_text_body1: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body1_layout: {
    position: 'absolute',
    flexGrow: 1,
    inset: '1317px 70px 206px'
  },
  group4: {
    display: 'flex'
  },
  group4_layout: {
    position: 'absolute',
    height: 18,
    width: 65,
    minWidth: 65,
    margin: '1317px 0px 208px',
    inset: '0px auto auto 103px'
  },
  decorator: {
    background: 'var(--src) center center / contain no-repeat'
  },
  decorator_layout: {
    position: 'absolute',
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px',
    inset: '0px auto auto 0px'
  },
  group5: {
    display: 'flex',
    opacity: 0.2
  },
  group5_layout: {
    position: 'absolute',
    width: 14,
    minWidth: 14,
    margin: '0px auto',
    inset: 0
  },
  img: {
    background: 'var(--src) center center / cover no-repeat'
  },
  img_layout: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 0px 1px'
  },
  group6: {
    display: 'flex',
    opacity: 0.2
  },
  group6_layout: {
    position: 'absolute',
    width: 14,
    minWidth: 14,
    inset: '0px auto 0px 12px'
  },
  group7: {
    display: 'flex',
    opacity: 0.2
  },
  group7_layout: {
    position: 'absolute',
    width: 14,
    minWidth: 14,
    inset: '0px 13px 0px auto'
  },
  group8: {
    display: 'flex',
    opacity: 0.2
  },
  group8_layout: {
    position: 'absolute',
    width: 14,
    minWidth: 14,
    inset: '0px 0px 0px auto'
  },
  group9: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  group9_layout: {
    position: 'absolute',
    height: 20,
    width: 59,
    minWidth: 59,
    margin: '1317px 0px 206px',
    inset: '0px auto auto 3px'
  },
  small_text_body_layout1: {
    height: 'min-content',
    width: 'fit-content',
    margin: '0px 0px 0px 18px'
  },
  flex: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex_layout: {
    position: 'absolute',
    flexGrow: 1,
    inset: '1347px 21px 116px 70px'
  },
  flex_item: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 20px'
  },
  flex1: {
    display: 'flex'
  },
  flex1_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex_item1: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 14px'
  },
  image_layout1: {
    height: 18,
    width: 9,
    minWidth: 9,
    margin: '2px 0px 0px auto'
  },
  flex_spacer: {
    flex: '0 0 auto',
    minWidth: 9
  },
  small_text_body2: {
    font: '12px/1.66 "Roboto", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body2_box: {},
  small_text_body2_box_layout: {
    flex: '1 1 auto'
  },
  small_text_body2_span0: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body2_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body3_box: {},
  small_text_body3_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body3_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span3: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span4: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body4: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body4_layout: {
    flex: '1 0 auto'
  },
  small_text_body5: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body5_box: {},
  small_text_body5_box_layout: {
    flex: '0 0 auto'
  },
  small_text_body5_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  group10: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  group10_layout: {
    position: 'absolute',
    height: 20,
    width: 59,
    minWidth: 59,
    margin: '1347px 0px 176px',
    inset: '0px auto auto 3px'
  },
  small_text_body_layout2: {
    height: 'min-content',
    width: 'fit-content',
    margin: '0px 0px 0px 18px'
  },
  group11: {
    display: 'flex',
    backgroundColor: 'rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  group11_layout: {
    position: 'absolute',
    minHeight: 44,
    flexGrow: 1,
    inset: '1439px 3px 60px'
  },
  highlights4: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights4_layout: {
    width: 64,
    minWidth: 64,
    margin: '8px auto'
  },
  group12: {
    display: 'flex'
  },
  group12_layout: {
    position: 'absolute',
    minHeight: 44,
    flexGrow: 1,
    inset: '1499px 3px 0px'
  },
  background: {
    border: '1px solid rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  background_layout: {
    position: 'absolute',
    height: 44,
    flexGrow: 1,
    inset: '0px 0px auto'
  },
  highlights5: {
    display: 'flex',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(94,117,111)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights5_layout: {
    width: 64,
    minWidth: 64,
    margin: '8px auto'
  },
  highlights6: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights6_layout: {
    position: 'absolute',
    flexGrow: 1,
    inset: '949px 3px 569px'
  },
  paragraph_body_layout1: {
    position: 'absolute',
    flexGrow: 1,
    inset: '981px 3px 474px'
  },
  decorator1: {
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  decorator1_layout: {
    position: 'absolute',
    height: 257,
    flexGrow: 1,
    margin: '671px 0px 615px',
    inset: '0px 0px auto 5px'
  },
  component: {},
  component_layout: {
    position: 'absolute',
    flexGrow: 1,
    inset: '54px 16px 1566px'
  }
});
